export default [
    {
        name: 'Intro',
        stories: null
    },
    { // 2
        name: 'driven',
        stories: null,
    }, // 2
    {  // 3
        name: 'belong',
        stories: null
    }, // 3
    { // 4
        name: 'self',
        stories: null
    }, // 4
    { // 5
        name: 'success',
        stories: null,
    }, // 5
    {
        name: 'purple',
        stories: null
    }, // 6
]